<ng-container *transloco="let t; read: 'communication-workflow-autocomplete'">
  <p-autoComplete
    appendTo="body"
    field="displayName"
    [dropdown]="true"
    dropdownAriaLabel="{{ t('autocompleteDropdownLabel') }}"
    [emptyMessage]="t('noOptionsFound')"
    [formControl]="control"
    [ngClass]="{ 'ng-invalid': control?.invalid }"
    [placeholder]="placeholder"
    [showEmptyMessage]="true"
    [suggestions]="(suggestedOptions$ | async) ?? []"
    (completeMethod)="search($event)"
  >
    <ng-template #itemDisplay let-value>
      <div class="flex gap-1 align-items-center">
        <mat-icon>lists</mat-icon>
        <span class="font-bold wrap">{{ value.getDisplayName() }}</span>
      </div>
    </ng-template>

    <ng-template pTemplate="item" let-value>
      <div class="flex flex-column gap-1">
        <ng-container *ngTemplateOutlet="itemDisplay; context: { $implicit: value }"></ng-container>
        <span class="text-sm">{{ value.getDescription() }}</span>
      </div>
    </ng-template>

    <ng-template pTemplate="selectedItem" let-value>
      <ng-container *ngTemplateOutlet="itemDisplay; context: { $implicit: value }"></ng-container>
    </ng-template>
  </p-autoComplete>

  <div *ngIf="control.errors as errors" class="p-error">
    <span *ngIf="errors.objIdNotInList">{{ t('controlErrorObjIdNotInList') }}</span>
  </div>
</ng-container>
